var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9928 17.0687C13.1246 17.0694 13.2552 17.0442 13.3772 16.9946C13.4992 16.9449 13.6102 16.8717 13.7038 16.7791C13.7976 16.6863 13.8721 16.5759 13.923 16.4542C13.9738 16.3326 14 16.2021 14 16.0703C14 15.9384 13.9738 15.8079 13.923 15.6863C13.8721 15.5646 13.7976 15.4542 13.7038 15.3614L10.3892 11.9991L13.7088 8.6367C13.8953 8.44963 14 8.19658 14 7.93281C14 7.66904 13.8953 7.41599 13.7088 7.22892C13.6157 7.13534 13.505 7.06107 13.3829 7.01038C13.2609 6.95969 13.13 6.93359 12.9978 6.93359C12.8656 6.93359 12.7347 6.95969 12.6127 7.01038C12.4907 7.06107 12.3799 7.13534 12.2868 7.22892L8.28626 11.3002C8.10277 11.4868 8 11.7377 8 11.9991C8 12.2604 8.10277 12.5113 8.28626 12.698L12.2918 16.7492C12.3817 16.846 12.4899 16.924 12.6102 16.9789C12.7306 17.0337 12.8606 17.0642 12.9928 17.0687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.3c7700cc675550c62b8df37696a9ecfe.svg";
export { ForwardRef as ReactComponent };